import { action, makeObservable, observable } from "mobx";
import { ErrorMessages } from "../errorMessage";
import Validator from "../validator";

export enum PaymentModeId {
    yearly = "YEARLY",
    quarterly = "QUARTERLY",
    oneTime = "ONE_TIME",
    halfYearly = "HALF_YEARLY"
}

export interface PaymentModeVariantsModel {
    installments: PaymentModeId | null;
    label: string | null;
}

export const PaymentModeVariants: PaymentModeVariantsModel[] = [
    {
        installments: PaymentModeId.oneTime,
        label: "jednorazowo"
    },
    {
        installments: PaymentModeId.halfYearly,
        label: "2 raty"
    },
    {
        installments: PaymentModeId.yearly,
        label: "rocznie (3 raty)"
    },
    {
        installments: PaymentModeId.quarterly,
        label: "kwartalnie (12 rat)"
    }
];

export interface PaymentModeModel {
    value: PaymentModeId | "";
    errorMessage: string;

    validatePaymentMode: () => void;
}

export class DefaultPaymentMode implements PaymentModeModel {
    @observable value: PaymentModeId | "";
    @observable errorMessage: string;

    constructor(value: PaymentModeId | "") {
        makeObservable(this);

        this.value = value;
        this.errorMessage = "";
    }

    @action
    public validatePaymentMode = () => {
        if (!Validator.isNotEmpty(this.value!)) {
            this.errorMessage = ErrorMessages.required;
        } else {
            this.errorMessage = "";
        }
    }
}
